import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import DarkMode from "../Component/DarkMode";
import { Button, Dropdown } from 'react-bootstrap';
import LogoMini from '../Component/Logo-mini';
import { API } from "../App"
import { toast } from 'react-toastify';
import Cookie from 'js-cookie'



const Header = ({ openSidebar }) => {
    const Navigate = useNavigate()
    const Cookieclear = async () => {
        console.log("in");
        const token = Cookie.set('pcjwt')
        const res = await API.post(`/logout`, {}, { headers: { "Authorization": `Bearer ${token}` } })
        Cookie.remove('pcjwt')
        toast.success("Logout Sucesfully", { position: "bottom-right", autoClose: 500 })
        Navigate("/")

    }

    return (
        <>
            <header className="sidebar-header">
                <div className="header-left-menu">
                    <Link to="/" className='d-xl-none'>
                        <LogoMini />
                    </Link>
                </div>
                <div className="header-right-menu">
                    <DarkMode />
                    <Dropdown>
                        <Dropdown.Toggle id="dropdown-autoclose-true">
                            <div className="user-menu">
                                <div className="user-img">
                                    <img src="../../logo/app-logo.svg" alt="Motivational Quotes" className='auth-logo' />
                                </div>
                                <div className="user-name ms-2">
                                    <h6>Photo-Caller</h6>
                                    <p>Admin</p>
                                </div>
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown-menu dropdown-menu-end">
                            <Dropdown.Item>
                                <a href="" onClick={Cookieclear}>
                                    <div className='Profile  dropDownBTN'>
                                        Logout
                                    </div>
                                </a>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Button className="burger-btn d-xl-none" onClick={openSidebar}>
                        <i className='bx bx-menu fs-3'></i>
                    </Button>
                </div>
            </header>
        </>
    )
}

export default Header;